import { render, staticRenderFns } from "./pemekaran_wilayah.vue?vue&type=template&id=18304dc1&"
import script from "./pemekaran_wilayah.vue?vue&type=script&lang=js&"
export * from "./pemekaran_wilayah.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports